export type MasterSearchCategory =
  | 'all'
  | 'context'
  | 'pages'
  | 'customers'
  | 'companies'
  | 'bookings'
  | 'pnrs'
  | 'invoices'
  | 'travelers'
  | 'suppliers'
  | 'trips'
  | 'documents'
  | 'tasks'
  | 'tickets';

export type MasterSearchResultType =
  | 'feature'
  | 'context'
  | 'customer'
  | 'company'
  | 'traveler'
  | 'booking'
  | 'pnr'
  | 'invoice'
  | 'pnt'
  | 'supplier'
  | 'trip'
  | 'document'
  | 'task'
  | 'ticket';

export const MASTER_SEARCH_CATEGORY_TYPES: Record<MasterSearchCategory, MasterSearchResultType[]> = {
  all: [],
  context: ['context'],
  pages: ['feature'],
  customers: ['customer'],
  companies: ['company'],
  bookings: ['booking', 'pnt'],
  pnrs: ['pnr'],
  invoices: ['invoice'],
  travelers: ['traveler'],
  suppliers: ['supplier'],
  trips: ['trip'],
  documents: ['document'],
  tasks: ['task'],
  tickets: ['ticket'],
};

export function buildMasterSearchEntityUrl(type: MasterSearchResultType, id: string): string {
  const encodedId = encodeURIComponent(id);
  switch (type) {
    case 'pnt':
      return `/pnt?status=All&q=${encodedId}`;
    case 'trip':
      return `/trips/${encodedId}`;
    case 'document':
      return `/crm/documents?document=${encodedId}`;
    case 'task':
      return `/tasks/management?task=${encodedId}`;
    default:
      throw new Error(`No canonical master-search URL is registered for ${type}`);
  }
}

export function quotePostgrestIlikePattern(value: string): string {
  const normalized = value.trim().replace(/\s+/g, ' ').slice(0, 120);
  const escaped = normalized.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  return `"%${escaped}%"`;
}
